import React, { useEffect, useState } from 'react'
import styles from './Project.module.css'
import { HoverState } from '../../assets/utils/cursorTypes';
import Section from '../Home/Section/Section';
import Projects from '../Home/Projects/Projects';
import { sanityClient, urlFor } from '../../assets/lib/sanity.client';
import { ProjectInterface } from '../../assets/lib/types/project';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { InfoProjectInterface } from '../../assets/lib/types/infoProject';
import RelatedProjects from './RelatedProjects/RelatedProjects';

export type ProjectProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
}

const Project = (props: ProjectProps) => {

    const [blurElement, setBlurElement] = useState('');
    const [project, setProject] = useState<ProjectInterface | null>(null);
    const [projectInfo, setProjectInfo] = useState<InfoProjectInterface[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        setIsLoading(true);
    
        const query = `*[
            _type == "project" &&
            _id == $id
        ]{
            ...
        }`;
    
        const query2 = `*[
            _type == "infoProject" &&
            project._ref == $id
        ]{
            ...
        }`;
    
        const fetchData = async () => {
            try {
                const [projectData, infoData] = await Promise.all([
                    (sanityClient as any).fetch(query, { id }),
                    (sanityClient as any).fetch(query2, { id }),
                ]);
    
                setProject(projectData[0]);
                setProjectInfo(infoData);
            } catch (error) {
                console.error(error);
                navigate("/");
            } finally {
                setIsLoading(false);
            }
        };
    
        fetchData();
    }, [id]);
    

    return (
        <div className={styles.container}>
            {project && (
                <div className={`${styles.section_content} ${!isLoading ? styles.loaded : ''}`}>
                    <div className={styles.section}>
                        <div className={styles.project_header}>
                            <span className={styles.title}>{project?.title}</span>
                        </div>
                        <div className={styles.project_info}>
                            <div className={styles.space}></div>
                            <span className={styles.description}>{project?.description}</span>
                            <div className={styles.project_content}>
                                <div className={styles.content_item}>
                                    <span>Client</span>
                                    <span>{project?.client}</span>
                                </div>
                                <div className={styles.content_item}>
                                    <span>Year</span>
                                    <span>{project?.year}</span>
                                </div>
                                <div className={styles.content_item}>
                                    <span>Timeline</span>
                                    <span>{project?.timeline}</span>
                                </div>
                                <div className={styles.content_item}>
                                    <span>Services</span>
                                    <div className={styles.content_item_services}>
                                        {project?.tags.map((item, index) => (
                                            <span key={index}>{item}</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.project_image}>
                                <img src={urlFor(project.image).url()} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className={styles.section}>
                        {projectInfo && (
                            <div className={styles.info_project_content}>
                                {projectInfo.map((item, index) => (
                                    <div className={styles.info_project} key={index}>
                                        <div className={styles.info_project_full}>
                                            <div className={styles.info_project_side}>
                                                <span className={styles.info_project_title}>{item.title}</span>
                                            </div>
                                            <div className={styles.info_project_side}>
                                                <div className={styles.info_project_desc}>
                                                    {item.description}
                                                </div>
                                                {/* map items */}
                                                {item.items && item.items.map((tags, index) => (
                                                    <div className={styles.info_project_desc} key={index}>
                                                        <span className={styles.desc_title}>{tags.title}: </span> 
                                                        <span className={styles.desc_content}>{tags.description}</span> 
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        {item.image ? (
                                        <div className={styles.project_image}>
                                            <img src={urlFor(item.image).url()} alt="" />
                                        </div>
                                        ): (
                                            <div className={styles.project_image2}></div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className={styles.space_blank}></div>
                    <div className={styles.section}>
                        <Section title='related projects' element={<RelatedProjects setHoverElement={props.setHoverElement} filterProject={project?.tags} idProject={project._id} />} isPage={false} blurElement={blurElement} setBlurElement={setBlurElement} setHoverElement={props.setHoverElement} />
                    </div>
                </div>
            )}
            <div className={styles.space_blank2}></div>
        </div>
    )
}

export default Project
